import {
  CreateUtilServiceDto,
  DeleteUtilServiceDto,
  EditUtilServiceDto,
  GetTenantServiceDto,
  GetUtilServiceDto,
  MessageResponseDto,
  UtilityServiceApiFp,
  UtilServiceControllerGet200Response,
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseUtilServiceModel = UtilServiceControllerGet200Response;
export type GetUtilServiceModel = GetUtilServiceDto;
export type MutateResponseUtilServiceModel = MessageResponseDto;
export type CreateUtilServiceModel = CreateUtilServiceDto;
export type UpdateUtilServiceModel = EditUtilServiceDto;
export type DeleteUtilServiceModel = DeleteUtilServiceDto;

export type GetPublicUtilServiceModel = GetTenantServiceDto;

export const apiUtilServiceFp = UtilityServiceApiFp(apiConfig);
export const getUtilServiceController =
  apiUtilServiceFp.utilServiceControllerGet;
export const createUtilServiceController =
  apiUtilServiceFp.utilServiceControllerCreate;
export const updateUtilServiceController =
  apiUtilServiceFp.utilServiceControllerEdit;
export const deleteUtilServiceController =
  apiUtilServiceFp.utilServiceControllerDelete;

export const getPublicUtilServiceController =
  apiUtilServiceFp.utilServiceControllerGetPublic;

export const QueryKeyUtilService = QueryKey.UtilService;
